import QuestionStore from './question-store/question-store';
import ChatStore from './chat-store/chat-store';
import AttendeesStore from './attendees-store/attendees-store';
import PollsStore from './polls-store/polls-store';
import { getLiveStreamStatusStore } from './live-stream-status-store/live-stream-status-store-instance';
import { getErrorBoundaryStore } from './error-boundary-store/error-boundary-store-instanse';
import { getPodiumInfoStore } from './podium-info-store/podium-info-store-instance';
import { getPermissionsStore } from './permissions-store/permissions-store-instance';
import { getPresenterSlideManagementStore } from './presenter-slide-management-store/presenter-slide-management-store-instance';
import { getAuthStore } from './auth-store/auth-store-intance';

const errorBoundaryStore = getErrorBoundaryStore();
const podiumInfoStore = getPodiumInfoStore();
const authStore = getAuthStore();
const permissionsStore = getPermissionsStore();
const slideManagementStore = getPresenterSlideManagementStore();
const liveStreamStatusStore = getLiveStreamStatusStore();

export const createStore = {
  podiumInfoStore,
  questionStore: new QuestionStore(),
  pollsStore: new PollsStore(),
  chatStore: new ChatStore(),
  attendeesStore: new AttendeesStore(),
  liveStreamStatusStore,
  authStore,
  slideManagementStore,
  errorBoundaryStore,
  permissionsStore
};
export type TStore = typeof createStore;
